import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { actionLogin, actionUserPswdUpdtDt } from '../../../module/LoginModule';
import { useCookies } from 'react-cookie';
import { FIND_ID_PW_PATH, HOME_PATH, JOIN_US_PHASE1, USER_INFO_PATH } from '../../../constant/Constant';
import PopupRef from '../../../component/PopupRef';
import PathUtil from '../../../util/PathUtil';
import ConfigUtil from '../../../util/ConfigUtil';

const LoginView = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userId, setUserId] = useState('');
    const [userPw, setUserPw] = useState('');
    const [isRemember, setIsRemember] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(['rememberMe']);
    const popupRef = useRef(null);

    const userIdElem = useRef(null);
    const userPwElem = useRef(null);

    const webType = ConfigUtil.getWebType().toLowerCase();

    const handleLogin = () => {
        if (userId == undefined || userId == null || userId == '') {
            alert('아이디를 입력해주세요.');
            userIdElem.current.focus();
        } else if (userPw == undefined || userPw == null || userPw == '') {
            alert('비밀번호를 입력해주세요.');
            userPwElem.current.focus();
        } else {
            dispatch(
                actionLogin({
                    userId,
                    userPw: btoa(userPw),
                    callback: (pwChangeRequired) => {
                        if (pwChangeRequired) {
                            popupRef.current.openExtension(
                                '비밀번호 사용 기한이 지나 변경이 필요합니다. 아래 버튼을 통해 조치해 주세요.',
                                () => {
                                    return function () {
                                        const path = PathUtil.pushState(USER_INFO_PATH, {
                                            userId,
                                        });
                                        navigate(path);
                                    };
                                },
                                () => {
                                    return function () {
                                        dispatch(
                                            actionUserPswdUpdtDt({
                                                data: { userId },
                                            }),
                                        );
                                        navigate(HOME_PATH);
                                    };
                                },
                            );
                        } else {
                            navigate(HOME_PATH);
                        }
                    },
                }),
            );
        }
    };

    useEffect(() => {
        if (cookies.rememberMe !== undefined) {
            setUserId(cookies.rememberMe);
            setIsRemember(true);
        }
    }, [cookies.rememberMe]);

    const handleUserId = (e) => {
        setUserId(e.target.value);
        if (isRemember) {
            setCookie('rememberMe', e.target.value, { maxAge: 2000 });
        }
    };

    const handleUserPw = (e) => {
        setUserPw(e.target.value);
    };

    const handleCheck = (e) => {
        setIsRemember(e.target.checked);
        if (e.target.checked) {
            setCookie('rememberMe', userId, { maxAge: 2000 });
        } else {
            removeCookie('rememberMe');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    const goJoin = () => {
        navigate(JOIN_US_PHASE1);
    };

    const goFindUserIdPw = () => {
        navigate(FIND_ID_PW_PATH);
    };

    return (
        <section className='container'>
            <div className='log-wrap'>
                <div className='log-inner'>
                    <div className='log-tit'>
                        <h2>로그인</h2>
                    </div>
                    <div className='log-form'>
                        <div className='form-box'>
                            <div className='input-box'>
                                <label htmlFor='text'>
                                    <span className='blind'>아이디를 입력하세요</span>
                                </label>
                                <div className='input-group'>
                                    <input
                                        type='email'
                                        className='form-control'
                                        placeholder='아이디를 입력하세요'
                                        value={userId}
                                        onChange={handleUserId}
                                        onKeyDown={handleKeyDown}
                                        ref={userIdElem}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='form-box'>
                            <div className='input-box'>
                                <label htmlFor='text'>
                                    <span className='blind'>비밀번호를 입력하세요</span>
                                </label>
                                <div className='input-group'>
                                    <input
                                        type='password'
                                        className='form-control'
                                        placeholder='비밀번호를 입력하세요'
                                        value={userPw}
                                        onChange={handleUserPw}
                                        onKeyDown={handleKeyDown}
                                        ref={userPwElem}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='log-btn'>
                            <button type='button' className={'btn positive'} onClick={handleLogin}>
                                로그인
                            </button>
                        </div>
                        <div className='log-find'>
                            <div className='form-box form-box-checkbox'>
                                <div className='input-box'>
                                    <div className='input-group'>
                                        <input
                                            type='checkbox'
                                            id='checkbox-1'
                                            className='form-control form-control-s'
                                            checked={isRemember}
                                            onChange={handleCheck}
                                        />
                                        <label htmlFor='checkbox-1'>
                                            <span>아이디 저장</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='find-btn'>
                                {webType != 'student' ? (
                                    <div></div>
                                ) : (
                                    <button type='button' className='btn' onClick={goJoin}>
                                        회원가입
                                    </button>
                                )}
                                <button type='button' className='btn' onClick={goFindUserIdPw}>
                                    아이디/비밀번호찾기
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default LoginView;
